import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import Login from "../screens/authentication/login/login";
import Dashboard from "../screens/main/workOrders";
import NotFound from "../screens/notFound";
import ProtectedRoute from "./protectedRoutes";
import Assets from "../screens/main/assetsScreen/assets";
import { AuthState } from "../redux/slices/authSlice";
import { PersistPartial } from "redux-persist/es/persistReducer";
import AddAsset from "../screens/main/addAsset/addAssets";
import Settings from "../screens/main/setting/setting";
import InspectionPoints from "../screens/main/inspection/inspection";
import OfflineSyncQueue from "../screens/main/offlineRequests/pendingRequestsQueue";
import InboundItems from "../screens/main/inboundItems";
import CreateItem from "../screens/main/inboundItems/createItem";
import EditItem from "../screens/main/inboundItems/editItem";
import MediaGallery from "../screens/main/inboundItems/mediaGallery";
import DashboardScreen from "../screens/main/dashboard";
import { FeatureFlagRoute } from "../components/FeatureFlag/FeatureFlagRoute";

const AppRoutes = () => {
  const { isAuthenticated } = useSelector(
    (state: RootState) => state.auth as AuthState & PersistPartial
  );

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            isAuthenticated ? (
              <Navigate to="/dashboard" />
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardScreen />
            </ProtectedRoute>
          }
        />

        <Route
          path="/login"
          element={isAuthenticated ? <Navigate to="/dashboard" /> : <Login />}
        />

        <Route
          path="/work-orders"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/inbound-items"
          element={
            <ProtectedRoute>
              <FeatureFlagRoute flag="enableTenantInboundAccess">
                <InboundItems />
              </FeatureFlagRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/inbound-items/create-item"
          element={
            <ProtectedRoute>
              <FeatureFlagRoute flag="enableTenantInboundAccess">
                <CreateItem />
              </FeatureFlagRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/inbound-items/:id/edit"
          element={
            <ProtectedRoute>
              <FeatureFlagRoute flag="enableTenantInboundAccess">
                <EditItem />
              </FeatureFlagRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/inbound-items/:id/media-gallery"
          element={
            <ProtectedRoute>
              <FeatureFlagRoute flag="enableTenantInboundAccess">
                <MediaGallery />
              </FeatureFlagRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/work-orders/:id"
          element={
            <ProtectedRoute>
              <Assets />
            </ProtectedRoute>
          }
        />
        <Route
          path="/add-asset/:id"
          element={
            <ProtectedRoute>
              <AddAsset />
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <Settings />
            </ProtectedRoute>
          }
        />
        <Route
          path="/pending-requests"
          element={
            <ProtectedRoute>
              <OfflineSyncQueue />
            </ProtectedRoute>
          }
        />
        <Route
          path="/work-orders/:workOrderId/inspection/:assetId"
          element={
            <ProtectedRoute>
              <InspectionPoints />
            </ProtectedRoute>
          }
        />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
